import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIDChildIFrameInstanceInit} from './UIDChildIFrameInstanceInit'

export class UIDiscordInstance {
    static _discordInstance: UIDChildIFrameInstanceInit

    static getDiscordInstance(): UIDChildIFrameInstanceInit {
        if(!UIUtilsEjsVariables.isUserOnDiscord) throw new Error('Not on Discord Activity')
        if(this._discordInstance == undefined) this._discordInstance = new UIDChildIFrameInstanceInit()
        return this._discordInstance
    }
}
